export default class MagazineViewHistoryDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  creditYn: number;
}
